module.exports = __webpack_public_path__ + "dccf61d68115ee1eee8b95e344022479.jpg";